import { Button, Form, Modal, Row, Table, Typography } from "antd";
import Icons from "assets/icons";
import { InputFields } from "components/common";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { dataFieldsMap, historyColumns } from "./config";
import { convertIosStringToDate } from "helper/common";
import "./DetailCardInfo.scss";

const DetailCardInfo = React.forwardRef((props, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState<any>(null);
  const [form] = Form.useForm();
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  useImperativeHandle(ref, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setData: setData,
  }));

  useEffect(() => {
    if (data !== null)
      form.setFieldsValue({
        ...data,
        ngayPhatHanh: convertIosStringToDate(data?.ngayPhatHanh),
        hetHan: convertIosStringToDate(data?.hetHan),
      });
  }, [data]);

  historyColumns.map((it) => {
    if (it.dataIndex === "lichSus") {
      it.render = (v, r, i) => {
        return (
          <Row>
            {v?.map((it) => {
              return (
                <Row>
                  <Typography.Text>{`${
                    convertIosStringToDate(it?.createDate ?? null)?.format(
                      "DD/MM/YYYY -"
                    ) || ""
                  } ${it.tenDichVu ?? ""}`}</Typography.Text>
                </Row>
              );
            })}
          </Row>
        );
      };
    }
    if (it.dataIndex === "soLanBanDau") {
      it.render = (v, r, i) => (v === -1 ? "KGH" : v);
    }
  });

  return (
    <div className="detail-card-info">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        title={"Thông tin thẻ khám"}
        destroyOnClose={true}
        width={1080}
      >
        <Row gutter={[8, 8]}>
          <Row>
            <Form form={form}>
              <Row gutter={[4, 8]}>
                <InputFields data={dataFieldsMap()} />
              </Row>
            </Form>
          </Row>
          <Row>
            <Table
              columns={historyColumns}
              dataSource={data?.dichVus ?? []}
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
              }}
              bordered
              style={{ width: "100%" }}
            />
          </Row>
          <Row justify={"end"} style={{ gap: "4px" }}>
            <Button type="default" icon={<Icons.close />} onClick={closeModal}>
              Đóng
            </Button>
          </Row>
        </Row>
      </Modal>
    </div>
  );
});

export default DetailCardInfo;
